import React, { Component } from 'react';
import _AdminService from '../../modules/AdminService';
import MyInput from '../../components/controls/MyInput';
import PageHeader from '../../components/enterprise/PageHeader';
import { routesAdmin } from '../../routes/Routes';

class License extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            KeyAllowedDays: 120,
            uniqKey: 'utkarshan25',
            licenseKey: '',
            validationToken: '',
            error: '',
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { KeyAllowedDays, uniqKey } = this.state;

        try {
            debugger
            let response = await _AdminService.GenerateLicenseKey({
                KeyAllowedDays: parseInt(KeyAllowedDays),
                uniqKey,
            });

            console.log("API Response:", response.data.IsSuccess);

            if (response.data.IsSuccess) {
                const [licenseKey, validationToken] = response.data.Message.split(':::');
                this.setState({
                    licenseKey: licenseKey,
                    validationToken: validationToken,
                    error: '',

                });
            } else {
                this.setState({ error: response?.Message || 'Failed to generate license key.' });
            }
        } catch (error) {
            console.error("API Error:", error);
            this.setState({ error: 'API call failed. Please try again.' });
        }
    };

    hideModelWindow = () => {
        if (this.modalRef.current) {
            this.modalRef.current.style.display = 'none';
        }
    };

    render() {
        const { KeyAllowedDays, uniqKey, licenseKey, validationToken, error } = this.state;

        return (
            <div className="max1000 m-auto">
                <PageHeader
                    title="License Key"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'License Key' }]}
                />

                <div className="ent-panel mt-5">
                    <h4 className="heading4">Generate License Key</h4>

                    <div className="admin-inner-wrap p-3">
                        <div className="row flex-sm-row">
                            <div className="ml-5 col-sm-4">
                                <MyInput
                                    id="KeyAllowedDays"
                                    type="number"
                                    key="KeyAllowedDays"
                                    name="KeyAllowedDays"
                                    value={KeyAllowedDays}
                                    onChange={this.handleChange}
                                    placeholder="Enter KeyAllowedDays"
                                    heading="Key Allowed Days:"
                                    isRequired={true}
                                />
                            </div>

                            <div className="col-sm-4 offset-sm-2">
                                <MyInput
                                    id="uniqKey"
                                    type="text"
                                    key="uniqKey"
                                    name="uniqKey"
                                    value={uniqKey}
                                    onChange={this.handleChange}
                                    placeholder="Enter uniqKey"
                                    heading="Unique Key:"
                                    isRequired={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="pt-4 buttonAlignCenter" >
                        <button type="button" onClick={this.handleSubmit} className="button-global button-primary autoHeight small"><span>Submit</span></button>
                    </div>

                    {/* Display Error or Result */}
                    <div className="pt-3">
                        {error && (
                            <p className="text-danger" style={{ fontWeight: 'bold' }}>
                                {error}
                            </p>
                        )}

                        {licenseKey && (
                            <div className="mt-3 p-3 border rounded bg-light">
                                <h5 className="mb-2">License Key:</h5>
                                <p className="mb-3 text-break" style={{ wordBreak: 'break-all' }}>
                                    <strong>{licenseKey}</strong>
                                </p>

                                <h5 className="mb-2">Unique Key:</h5>
                                <p className="text-break" style={{ wordBreak: 'break-all' }}>
                                    <strong>{validationToken}</strong>
                                </p>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default License;
